export const EXTERNAL_AUTHENTICATIONS_RESET_STATE = 'EXTERNAL_AUTHENTICATIONS_RESET_STATE';
export const EXTERNAL_AUTHENTICATIONS_CURRENT_ITEM = 'EXTERNAL_AUTHENTICATIONS_CURRENT_ITEM';

export const EXTERNAL_AUTHENTICATIONS_REQUEST_LOADING = 'EXTERNAL_AUTHENTICATIONS_REQUEST_LOADING';
export const EXTERNAL_AUTHENTICATIONS_REQUEST_SUCCESS = 'EXTERNAL_AUTHENTICATIONS_REQUEST_SUCCESS';
export const EXTERNAL_AUTHENTICATIONS_REQUEST_FAILED = 'EXTERNAL_AUTHENTICATIONS_REQUEST_FAILED';

export const EXTERNAL_AUTHENTICATIONS_CURRENT_ACTION = 'EXTERNAL_AUTHENTICATIONS_CURRENT_ACTION';
export const EXTERNAL_AUTHENTICATIONS_RESET_ACTION = 'EXTERNAL_AUTHENTICATIONS_RESET_ACTION';